// extracted by mini-css-extract-plugin
module.exports = {"body":"body_body__1VMhV"};